<div class="main">
    <div class="container-fluid">
        <!-- Header Section -->
        <div class="tenders-header d-flex flex-wrap justify-content-between align-items-center m-4">
            <div class="tenders-title-container mb-3 mb-md-0">
                <button class="btn back-btn p-0 mb-2 d-flex align-items-center" (click)="goBack()" [attr.aria-label]="'Go back to ' + entityLabelPlural">
                    <i class="fas fa-arrow-left me-2"></i>
                    Go back to {{ entityLabelPlural }}
                </button>
                <h3>Create {{ entityLabel }}</h3>
                <span>
                    <a [routerLink]="['/' + AppConstants.ROUTES.HOME]" class="tenders-header-title breadcrumb-link">Dashboard <i class="lni lni-chevron-right" aria-hidden="true"></i></a>
                    <a [routerLink]="['/' + (isFwaPracticeMode ? AppConstants.ROUTES.FWA_PRACTICE : (isPracticeMode ? AppConstants.ROUTES.PRACTICE : AppConstants.ROUTES.TENDER))]" class="tenders-header-title breadcrumb-link">{{ entityLabelPlural }} <i class="lni lni-chevron-right" aria-hidden="true"></i></a>
                    <span>Create {{ entityLabel }}</span>
                </span>
            </div>
        </div>

        <!-- Navigation Tabs -->
        <div class="tabs-navigation m-4">
            <div class="tabs-container">
                <div class="tabs-wrapper">
                    <button 
                        *ngFor="let tab of displayTabs" 
                        class="tab-item" 
                        [class.active]="isTabActive(tab)"
                        (click)="setTab(tab)">
                        {{ tab }}
                    </button>
                </div>
                <button class="btn create-btn" (click)="createTender()">
                    Create {{ entityLabel }}
                </button>
            </div>
        </div>

        
        <!-- Tender Line Tab Content -->
        <div class="mandatory-application m-4" *ngIf="activeTab === 'Tender'">
            <div class="inside-out p-4">
                <div class="mandatory-fields"></div>
                <form [formGroup]="tenderForm">
                    <div class="container pt-4">
                        <!-- General Section -->
                        <fieldset class="content-fieldset mb-4">
                            <legend class="section-legend">General</legend>
                            
                            <!-- Purchase Requisition - First Field -->
                            <div class="row mb-4">
                                <div class="col-12 col-md-4">
                                    <label class="form-label fw-bold" [appRequiredField]="'purchaseRequisition'">
                                        Purchase requisition
                                    </label>
                                    <app-searchable-select
                                        [options]="purchaseRequisitions"
                                        [label]="''"
                                        [id]="'purchaseRequisitionLine'"
                                        [placeholder]="'Search or select requisition...'"
                                        [inputClass]="'form-control rounded-4 p-2' + (hasFieldError('purchaseRequisition') ? ' is-invalid' : '')"
                                        formControlName="purchaseRequisition">
                                    </app-searchable-select>
                                    <small class="text-muted" *ngIf="isPRSelected">
                                        Fields below will be auto-populated from PR and cannot be modified
                                    </small>
                                    <div class="text-danger small mt-1" *ngIf="hasFieldError('purchaseRequisition')">
                                        {{ getFieldError('purchaseRequisition') }}
                                    </div>
                                </div>
                            </div>
                            
                            <div class="row mb-4">
                                <!-- Row 1 -->
                                <div class="col-12 col-md-4 mb-3">
                                    <label for="tenderNameLine" class="form-label fw-bold" [appRequiredField]="'tenderName'">
                                        {{ entityLabel }} name
                                    </label>
                                    <input 
                                        type="text" 
                                        id="tenderNameLine" 
                                        class="form-control rounded-4 p-2" 
                                        [class.is-invalid]="hasFieldError('tenderName')"
                                        [class.bg-light]="isPRSelected"
                                        [readonly]="isPRSelected"
                                        formControlName="tenderName" 
                                        [placeholder]="'Enter ' + entityLabelLower + ' name'">
                                    <div class="text-danger small mt-1" *ngIf="hasFieldError('tenderName')">
                                        {{ getFieldError('tenderName') }}
                                    </div>
                                </div>
                                <div class="col-12 col-md-4 mb-3">
                                    <label for="tenderValueLine" class="form-label fw-bold" [appRequiredField]="'tenderValue'">
                                        {{ entityLabel }} Value (QAR)
                                    </label>
                                    <input 
                                        type="text" 
                                        id="tenderValueLine" 
                                        class="form-control rounded-4 p-2" 
                                        [class.is-invalid]="hasFieldError('tenderValue')"
                                        [class.bg-light]="isPRSelected"
                                        [readonly]="isPRSelected"
                                        formControlName="tenderValue" 
                                        [placeholder]="'Enter ' + entityLabelLower + ' value'">
                                    <div class="text-danger small mt-1" *ngIf="hasFieldError('tenderValue')">
                                        {{ getFieldError('tenderValue') }}
                                    </div>
                                </div>
                                <div class="col-12 col-md-4 mb-3">
                                    <label for="noteLine" class="form-label fw-bold">Note</label>
                                    <textarea 
                                        id="noteLine" 
                                        class="form-control rounded-4 p-2" 
                                        [class.bg-light]="isPRSelected"
                                        [readonly]="isPRSelected"
                                        formControlName="note" 
                                        rows="3" 
                                        placeholder="Enter note"></textarea>
                                </div>

                                <!-- Row 2 -->
                                <div class="col-12 col-md-4 mb-3">
                                    <label class="form-label fw-bold" [appRequiredField]="'tenderType'">
                                        {{ entityLabel }} Type
                                    </label>
                                    <app-searchable-select
                                        [options]="tenderTypes"
                                        [label]="''"
                                        [id]="'tenderTypeLine'"
                                        [placeholder]="'Search or select type...'"
                                        [inputClass]="'form-control rounded-4 p-2' + (hasFieldError('tenderType') ? ' is-invalid' : '')"
                                        formControlName="tenderType">
                                    </app-searchable-select>
                                    <div class="text-danger small mt-1" *ngIf="hasFieldError('tenderType')">
                                        {{ getFieldError('tenderType') }}
                                    </div>
                                </div>
                                <div class="col-12 col-md-4 mb-3">
                                    <label class="form-label fw-bold" [appRequiredField]="'currency'">
                                        Currency
                                    </label>
                                    <app-searchable-select
                                        [options]="currencies"
                                        [label]="''"
                                        [id]="'currencyLine'"
                                        [placeholder]="'Search or select currency...'"
                                        [inputClass]="'form-control rounded-4 p-2' + (hasFieldError('currency') ? ' is-invalid' : '')"
                                        formControlName="currency">
                                    </app-searchable-select>
                                    <div class="text-danger small mt-1" *ngIf="hasFieldError('currency')">
                                        {{ getFieldError('currency') }}
                                    </div>
                                </div>
                                <div class="col-12 col-md-4 mb-3">
                                    <label for="recommendationJustificationLine" class="form-label fw-bold">Recommendation / justification</label>
                                    <textarea 
                                        id="recommendationJustificationLine" 
                                        class="form-control rounded-4 p-2" 
                                        [class.bg-light]="isPRSelected"
                                        [readonly]="isPRSelected"
                                        formControlName="recommendationJustification" 
                                        rows="3" 
                                        placeholder="Enter recommendation"></textarea>
                                </div>

                                <!-- Row 3 -->
                                <div class="col-12 col-md-4 mb-3">
                                    <label class="form-label fw-bold" [appRequiredField]="'rfpRfq'">RFP / RFQ</label>
                                    <app-searchable-select
                                        [options]="rfpRfqOptions"
                                        [label]="''"
                                        [id]="'rfpRfqLine'"
                                        [placeholder]="'Search or select option...'"
                                        [inputClass]="'form-control rounded-4 p-2' + (hasFieldError('rfpRfq') ? ' is-invalid' : '')"
                                        formControlName="rfpRfq">
                                    </app-searchable-select>
                                    <div class="text-danger small mt-1" *ngIf="hasFieldError('rfpRfq')">
                                        {{ getFieldError('rfpRfq') }}
                                    </div>
                                </div>
                                <!-- <div class="col-12 col-md-4 mb-3">
                                    <label for="tenderValueInQARLine" class="form-label fw-bold">{{ entityLabel }} value in QAR</label>
                                    <input type="text" id="tenderValueInQARLine" class="form-control rounded-4 bg-light p-2" formControlName="tenderValueInQAR" placeholder="Enter value in QAR">
                                </div> -->
                                <div class="col-12 col-md-4 mb-3">
                                    <label class="form-label fw-bold">Is joining fee required</label>
                                    <div class="d-flex gap-3">
                                        <div class="form-check">
                                            <input class="form-check-input" type="radio" name="isJoiningFeeRequired" id="joiningFeeYesLine" value="Yes" formControlName="isJoiningFeeRequired">
                                            <label class="form-check-label" for="joiningFeeYesLine">Yes</label>
                                        </div>
                                        <div class="form-check">
                                            <input class="form-check-input" type="radio" name="isJoiningFeeRequired" id="joiningFeeNoLine" value="No" formControlName="isJoiningFeeRequired">
                                            <label class="form-check-label" for="joiningFeeNoLine">No</label>
                                        </div>
                                    </div>
                                </div>

                                <!-- Row 4 -->
                                <div class="col-12 col-md-4 mb-3">
                                    <app-searchable-select
                                        [options]="tenderClassifications"
                                        [label]="entityLabel + ' Classification'"
                                        [id]="'tenderClassificationLine'"
                                        [placeholder]="'Search or select classification...'"
                                        formControlName="tenderClassification">
                                    </app-searchable-select>
                                </div>
                                <div class="col-12 col-md-4 mb-3" *ngIf="tenderForm.get('isJoiningFeeRequired')?.value === 'Yes'">
                                    <label for="joiningFeeLine" class="form-label fw-bold" [appRequiredField]="'joiningFee'">Joining fee</label>
                                    <input 
                                        type="text" 
                                        id="joiningFeeLine" 
                                        class="form-control rounded-4 bg-light p-2" 
                                        [class.is-invalid]="hasFieldError('joiningFee')"
                                        formControlName="joiningFee" 
                                        placeholder="Enter joining fee">
                                    <div class="text-danger small mt-1" *ngIf="hasFieldError('joiningFee')">
                                        {{ getFieldError('joiningFee') }}
                                    </div>
                                </div>

                                <!-- Row 5 -->
                                <div class="col-12 col-md-4 mb-3">
                                    <label for="companyLine" class="form-label fw-bold">Company</label>
                                    <input type="text" id="companyLine" class="form-control rounded-4 bg-light p-2" formControlName="company" placeholder="Enter company name">
                                </div>
                                <!-- <div class="col-12 col-md-4 mb-3">
                                    <label for="bidClosureDateLine" class="form-label fw-bold">Bid closure date</label>
                                    <input type="date" id="bidClosureDateLine" class="form-control rounded-4 bg-light p-2" formControlName="bidClosureDate">
                                </div> -->

                                <!-- Row 6 -->
                                <div class="col-12 col-md-4 mb-3">
                                    <app-searchable-select
                                        [options]="euDepartments"
                                        [label]="'Department'"
                                        [id]="'euDepartmentLine'"
                                        [placeholder]="'Search or select department...'"
                                        formControlName="euDepartment">
                                    </app-searchable-select>
                                </div>
                                <div class="col-12 col-md-4 mb-3">
                                    <app-searchable-select
                                        [options]="spocOptions"
                                        [label]="'Department SPOC'"
                                        [id]="'euDepartmentSpocLine'"
                                        [placeholder]="'Search or select SPOC...'"
                                        formControlName="euDepartmentSpoc">
                                    </app-searchable-select>
                                </div>
                                <div class="col-12 col-md-4 mb-3">
                                    <app-searchable-select
                                        [options]="spocOptions"
                                        [label]="'Managed by SPOC'"
                                        [id]="'managedBySpocLine'"
                                        [placeholder]="'Search or select SPOC...'"
                                        formControlName="managedBySpoc">
                                    </app-searchable-select>
                                </div>

                                <!-- Row 7 -->
                                <div class="col-12 col-md-4 mb-3">
                                    <label for="managedByContactDetailsLine" class="form-label fw-bold">Managed by contact details (SPOC)</label>
                                    <textarea id="managedByContactDetailsLine" class="form-control rounded-4 bg-light p-2" formControlName="managedByContactDetails" rows="3" placeholder="Enter contact details"></textarea>
                                </div>
                                <!-- <div class="col-12 col-md-4 mb-3">
                                    <label for="startDateOfTenderLine" class="form-label fw-bold" [appRequiredField]="'startDateOfTender'">Start date of {{ entityLabelLower }}</label>
                                    <input 
                                        type="date" 
                                        id="startDateOfTenderLine" 
                                        class="form-control rounded-4 bg-light p-2" 
                                        [class.is-invalid]="hasFieldError('startDateOfTender')"
                                        formControlName="startDateOfTender">
                                    <div class="text-danger small mt-1" *ngIf="hasFieldError('startDateOfTender')">
                                        {{ getFieldError('startDateOfTender') }}
                                    </div>
                                </div> -->
                                <div class="col-12 col-md-4 mb-3">
                                    <label for="acceptanceDeadlineLine" class="form-label fw-bold" [appRequiredField]="'acceptanceDeadline'">Acceptance deadline</label>
                                    <input type="date" id="acceptanceDeadlineLine" class="form-control rounded-4 bg-light p-2" [class.is-invalid]="hasFieldError('acceptanceDeadline')" formControlName="acceptanceDeadline">
                                    <div class="text-danger small mt-1" *ngIf="hasFieldError('acceptanceDeadline')">{{ getFieldError('acceptanceDeadline') }}</div>
                                </div>
                            </div>
                        </fieldset>
                        
                        <!-- Selected vendor Section - Only show for Private tenders -->
                        <fieldset class="content-fieldset mb-4" *ngIf="isPrivateTender">
                            <legend class="section-legend">Selected vendor</legend>
                            
                            <div class="d-flex gap-2 mb-3">
                                <button type="button" class="btn action-btn" (click)="addSelectedVendor()">
                                    + Add
                                </button>
                                <button 
                                    type="button" 
                                    class="btn action-btn" 
                                    (click)="removeAllSelectedVendors()"
                                    [disabled]="selectedVendorsFormArray.length <= 1">
                                    <i class="fas fa-trash"></i> Remove
                                </button>
                            </div>
                            
                            <div class="table-responsive">
                                <table class="table table-bordered">
                                    <thead>
                                        <tr>
                                            <th>Vendor account</th>
                                            <th>Name</th>
                                            <th></th>
                                        </tr>
                                    </thead>
                                    <tbody formArrayName="selectedVendors">
                                        <tr *ngFor="let vendor of selectedVendorsFormArray.controls; let i = index" [formGroupName]="i">
                                            <td>
                                                <app-searchable-select
                                                    [options]="vendorAccounts"
                                                    [id]="'vendorAccount_' + i"
                                                    [placeholder]="'Search or select vendor...'"
                                                    [label]="''"
                                                    formControlName="vendorAccount">
                                                </app-searchable-select>
                                            </td>
                                            <td>
                                                <input 
                                                    type="text" 
                                                    class="form-control rounded-4 bg-light p-2" 
                                                    formControlName="vendorName" 
                                                    readonly>
                                            </td>
                                            <td class="text-center">
                                                <button 
                                                    type="button" 
                                                    class="btn action-btn btn-sm" 
                                                    (click)="removeSelectedVendor(i)"
                                                    title="Remove">
                                                    <i class="fas fa-trash"></i> Remove
                                                </button>
                                            </td>
                                        </tr>
                                    </tbody>
                                </table>
                            </div>
                        </fieldset>
                        
                        <!-- Evaluation Criteria Section -->
                        <fieldset class="content-fieldset mb-4">
                            <legend class="section-legend">Evaluation Criteria</legend>
                            
                            <div class="mb-3">
                                <label for="backgroundAndSOW" class="form-label fw-bold">Background and SOW</label>
                                <textarea 
                                    id="backgroundAndSOW" 
                                    class="form-control rounded-4 bg-light p-2" 
                                    formControlName="backgroundAndSOW" 
                                    rows="3" 
                                    placeholder="Enter background and SOW">
                                </textarea>
                            </div>
                            
                            <div class="mb-3">
                                <label for="technicalEvaluation" class="form-label fw-bold">Technical evaluation</label>
                                <textarea 
                                    id="technicalEvaluation" 
                                    class="form-control rounded-4 bg-light p-2" 
                                    formControlName="technicalEvaluation" 
                                    rows="3" 
                                    placeholder="Enter technical evaluation">
                                </textarea>
                            </div>
                            
                            <div class="mb-3">
                                <label for="commercialEvaluation" class="form-label fw-bold">Commercial evaluation</label>
                                <textarea 
                                    id="commercialEvaluation" 
                                    class="form-control rounded-4 bg-light p-2" 
                                    formControlName="commercialEvaluation" 
                                    rows="3" 
                                    placeholder="Enter commercial evaluation">
                                </textarea>
                            </div>
                        </fieldset>
                        
                        <!-- EVALUATION CRITERIA Section -->
                        <fieldset class="content-fieldset mb-4">
                            <legend class="section-legend">Evaluation Criteria</legend>
                            
                            <app-evaluation-criteria
                                [initialData]="evaluationCriteriaData"
                                [readonly]="false"
                                [isPRSelected]="isPRSelected"
                                (dataChange)="onEvaluationCriteriaChange($event)">
                            </app-evaluation-criteria>
                        </fieldset>
                        
                        <!-- Pre-Qualification Criteria / Instructions Section -->
                        <fieldset class="content-fieldset mb-4">
                            <legend class="section-legend">Pre-Qualification Criteria / Instructions</legend>
                            
                            <div class="row mb-4">
                                <!-- Left Sub-section: Tender bond -->
                            <div class="col-12 col-md-6">
                                <div class="mb-3">
                                        <label class="form-label fw-bold">Tender bond required</label>
                                        <div class="d-flex gap-3">
                                            <div class="form-check">
                                                <input class="form-check-input" type="radio" name="tenderBondRequired" id="tenderBondYes" value="Yes" formControlName="tenderBondRequired">
                                                <label class="form-check-label" for="tenderBondYes">Yes</label>
                                            </div>
                                            <div class="form-check">
                                                <input class="form-check-input" type="radio" name="tenderBondRequired" id="tenderBondNo" value="No" formControlName="tenderBondRequired">
                                                <label class="form-check-label" for="tenderBondNo">No</label>
                                            </div>
                                        </div>
                                    </div>
                                    
                                    <div class="mb-3" *ngIf="tenderForm.get('tenderBondRequired')?.value === 'Yes'">
                                        <label for="tenderBondDetails" class="form-label fw-bold" [appRequiredField]="'tenderBondDetails'">{{ entityLabel }} bond details</label>
                                        <textarea 
                                            id="tenderBondDetails" 
                                            class="form-control rounded-4 bg-light p-2" 
                                            [class.is-invalid]="hasFieldError('tenderBondDetails')"
                                            formControlName="tenderBondDetails" 
                                            rows="3" 
                                            [placeholder]="'Enter ' + entityLabelLower + ' bond details'">
                                        </textarea>
                                        <div class="text-danger small mt-1" *ngIf="hasFieldError('tenderBondDetails')">
                                            {{ getFieldError('tenderBondDetails') }}
                                        </div>
                                    </div>
                                    
                                    <div class="mb-3" *ngIf="tenderForm.get('tenderBondRequired')?.value === 'Yes'">
                                        <label for="tenderBondValidityDate" class="form-label fw-bold" [appRequiredField]="'tenderBondValidityDate'">{{ entityLabel }} bond validity date</label>
                                        <input 
                                            type="date" 
                                            id="tenderBondValidityDate" 
                                            class="form-control rounded-4 bg-light p-2" 
                                            [class.is-invalid]="hasFieldError('tenderBondValidityDate')"
                                            formControlName="tenderBondValidityDate">
                                        <div class="text-danger small mt-1" *ngIf="hasFieldError('tenderBondValidityDate')">
                                            {{ getFieldError('tenderBondValidityDate') }}
                                        </div>
                                    </div>
                                </div>
                                
                                <!-- Right Sub-section: Performance bond -->
                                <div class="col-12 col-md-6">
                                    <div class="mb-3">
                                        <label class="form-label fw-bold">Performance bond required</label>
                                        <div class="d-flex gap-3">
                                            <div class="form-check">
                                                <input class="form-check-input" type="radio" name="performanceBondRequired" id="performanceBondYes" value="Yes" formControlName="performanceBondRequired">
                                                <label class="form-check-label" for="performanceBondYes">Yes</label>
                                            </div>
                                            <div class="form-check">
                                                <input class="form-check-input" type="radio" name="performanceBondRequired" id="performanceBondNo" value="No" formControlName="performanceBondRequired">
                                                <label class="form-check-label" for="performanceBondNo">No</label>
                                            </div>
                                        </div>
                                    </div>
                                    
                                    <div class="mb-3" *ngIf="tenderForm.get('performanceBondRequired')?.value === 'Yes'">
                                        <label for="performanceBondDetails" class="form-label fw-bold" [appRequiredField]="'performanceBondDetails'">Performance bond details</label>
                                        <textarea 
                                            id="performanceBondDetails" 
                                            class="form-control rounded-4 bg-light p-2" 
                                            [class.is-invalid]="hasFieldError('performanceBondDetails')"
                                            formControlName="performanceBondDetails" 
                                            rows="3" 
                                            placeholder="Enter performance bond details">
                                        </textarea>
                                        <div class="text-danger small mt-1" *ngIf="hasFieldError('performanceBondDetails')">
                                            {{ getFieldError('performanceBondDetails') }}
                                        </div>
                                    </div>
                                    
                                    <div class="mb-3" *ngIf="tenderForm.get('performanceBondRequired')?.value === 'Yes'">
                                        <label for="performanceBondValidityDate" class="form-label fw-bold" [appRequiredField]="'performanceBondValidityDate'">Performance bond validity date</label>
                                        <input 
                                            type="date" 
                                            id="performanceBondValidityDate" 
                                            class="form-control rounded-4 bg-light p-2" 
                                            [class.is-invalid]="hasFieldError('performanceBondValidityDate')"
                                            formControlName="performanceBondValidityDate">
                                        <div class="text-danger small mt-1" *ngIf="hasFieldError('performanceBondValidityDate')">
                                            {{ getFieldError('performanceBondValidityDate') }}
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </fieldset>
                        
                        <!-- Tender committee voting Section - COMMENTED OUT -->
                        <fieldset class="content-fieldset mb-4" *ngIf="false">
                            <legend class="section-legend">Tender committee voting</legend>
                            
                        <div class="row mb-4">
                                <!-- Left Sub-section -->
                            <div class="col-12 col-md-6">
                                <div class="mb-3">
                                        <label for="sourceType" class="form-label fw-bold">Source Type</label>
                                        <select 
                                            id="sourceType" 
                                            class="form-control rounded-4 bg-light p-2" 
                                            formControlName="sourceType">
                                            <option value="">Select Source Type</option>
                                            <option *ngFor="let type of sourceTypes" [value]="type">
                                                {{ type }}
                                            </option>
                                        </select>
                                    </div>
                                    
                                    <div class="mb-3">
                                        <label class="form-label fw-bold">Addendum</label>
                                        <div class="d-flex gap-3">
                                            <div class="form-check">
                                                <input class="form-check-input" type="radio" name="addendum" id="addendumYes" value="Yes" formControlName="addendum">
                                                <label class="form-check-label" for="addendumYes">Yes</label>
                                            </div>
                                            <div class="form-check">
                                                <input class="form-check-input" type="radio" name="addendum" id="addendumNo" value="No" formControlName="addendum">
                                                <label class="form-check-label" for="addendumNo">No</label>
                                            </div>
                                        </div>
                                    </div>
                                    
                                    <div class="mb-3">
                                        <label for="addendumPercent" class="form-label fw-bold">Addendum %</label>
                                    <input 
                                            type="text" 
                                            id="addendumPercent" 
                                            class="form-control rounded-4 bg-light p-2" 
                                            formControlName="addendumPercent" 
                                            placeholder="Enter addendum percentage">
                                    </div>
                                    
                                    <div class="mb-3">
                                        <label for="remarksImportantNote" class="form-label fw-bold">Remarks / Important note</label>
                                        <textarea 
                                            id="remarksImportantNote" 
                                        class="form-control rounded-4 bg-light p-2" 
                                            formControlName="remarksImportantNote" 
                                            rows="3" 
                                            placeholder="Enter remarks or important notes">
                                        </textarea>
                                    </div>
                                    
                                    <div class="mb-3">
                                        <label class="form-label fw-bold">Is Urgent</label>
                                        <div class="d-flex gap-3">
                                            <div class="form-check">
                                                <input class="form-check-input" type="radio" name="isUrgent" id="isUrgentYes" value="Yes" formControlName="isUrgent">
                                                <label class="form-check-label" for="isUrgentYes">Yes</label>
                                            </div>
                                            <div class="form-check">
                                                <input class="form-check-input" type="radio" name="isUrgent" id="isUrgentNo" value="No" formControlName="isUrgent">
                                                <label class="form-check-label" for="isUrgentNo">No</label>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                
                                <!-- Right Sub-section -->
                            <div class="col-12 col-md-6">
                                <div class="mb-3">
                                        <label for="currencyVoting" class="form-label fw-bold">Currency</label>
                                        <select 
                                            id="currencyVoting" 
                                            class="form-control rounded-4 bg-light p-2" 
                                            formControlName="currencyVoting">
                                            <option value="">Select Currency</option>
                                            <option *ngFor="let curr of currencies" [value]="curr">
                                                {{ curr }}
                                            </option>
                                        </select>
                                    </div>
                                    
                                    <div class="mb-3">
                                        <label for="previousAddendumValue" class="form-label fw-bold">Previous addendum value</label>
                                    <input 
                                        type="text" 
                                            id="previousAddendumValue" 
                                            class="form-control rounded-4 bg-light p-2" 
                                            formControlName="previousAddendumValue" 
                                            placeholder="Enter previous addendum value">
                                    </div>
                                    
                                    <div class="mb-3">
                                        <label for="procurementRecommendation" class="form-label fw-bold">Procurement Recommendation</label>
                                        <textarea 
                                            id="procurementRecommendation" 
                                            class="form-control rounded-4 bg-light p-2" 
                                            formControlName="procurementRecommendation" 
                                            rows="3" 
                                            placeholder="Enter procurement recommendation">
                                        </textarea>
                                    </div>
                                    
                                    <div class="mb-3">
                                        <label for="recommendedVendor" class="form-label fw-bold">Recommended vendor</label>
                                        <select 
                                            id="recommendedVendor" 
                                        class="form-control rounded-4 bg-light p-2" 
                                            formControlName="recommendedVendor">
                                            <option value="">Select Recommended Vendor</option>
                                            <option *ngFor="let vendor of recommendedVendors" [value]="vendor">
                                                {{ vendor }}
                                            </option>
                                        </select>
                                    </div>
                                </div>
                            </div>
                        </fieldset> 
                    </div>
                </form>
            </div>
                    </div>

        <!-- Documents Tab Content -->
        <div class="mandatory-application m-4" *ngIf="activeTab === 'Documents'">
            <div class="inside-out p-4">
                <div class="mandatory-fields"></div>
                <form [formGroup]="tenderForm">
                    <div class="container pt-4">
                        <!-- Tender/Practice Documents Section -->
                        <fieldset class="content-fieldset mb-4">
                            <legend class="section-legend">{{ entityLabel }} Documents</legend>
                            
                            <div class="d-flex gap-2 mb-3">
                                <button type="button" class="btn action-btn" (click)="addTenderDocument()">
                                    + Add Document
                                </button>
                            </div>
                            
                            <div class="table-responsive" *ngIf="tenderDocumentsFormArray.length > 0">
                                <table class="table table-bordered">
                                    <thead>
                                        <tr>
                                            <th>Document Name</th>
                                            <th>File</th>
                                            <th>Additional Details</th>
                                            <th>Action</th>
                                        </tr>
                                    </thead>
                                    <tbody formArrayName="tenderDocuments">
                                        <tr *ngFor="let doc of tenderDocumentsFormArray.controls; let i = index" [formGroupName]="i">
                                            <td>
                                                <input 
                                                    type="text" 
                                                    class="form-control rounded-4 bg-light p-2" 
                                                    formControlName="name" 
                                                    placeholder="Enter document name">
                                            </td>
                                            <td>
                                                <input 
                                                    type="file" 
                                                    class="form-control rounded-4 bg-light p-2" 
                                                    (change)="onFileSelected($event, i, 'tender')"
                                                    accept=".pdf,.doc,.docx,.xls,.xlsx,.jpg,.jpeg,.png">
                                                <small class="text-muted" *ngIf="doc.get('name')?.value">
                                                    Selected: {{ doc.get('name')?.value }}
                                                </small>
                                            </td>
                                            <td>
                                                <textarea 
                                                    class="form-control rounded-4 bg-light p-2" 
                                                    formControlName="additionalDetails" 
                                                    rows="2" 
                                                    placeholder="Enter additional details">
                                                </textarea>
                                            </td>
                                            <td class="text-center">
                                                <button 
                                                    type="button" 
                                                    class="btn action-btn btn-sm" 
                                                    (click)="removeTenderDocument(i)"
                                                    title="Remove">
                                                    <i class="fas fa-trash"></i> Remove
                                                </button>
                                            </td>
                                        </tr>
                                    </tbody>
                                </table>
                            </div>
                            
                            <div class="alert alert-info" *ngIf="tenderDocumentsFormArray.length === 0">
                                No {{ entityLabelLower }} documents added yet. Click "Add Document" to upload documents.
                            </div>
                        </fieldset>
                    </div>
                </form>
            </div>
        </div>
    </div>
</div>
